import { SVGProps } from "react";

const CalendarNextIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="34"
      height="35"
      viewBox="0 0 34 35"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9902 34.2012C7.89479 34.2012 0.521484 26.8279 0.521484 17.7324C0.521485 8.63698 7.8948 1.26367 16.9902 1.26367C26.0857 1.26367 33.459 8.63698 33.459 17.7324C33.459 26.8279 26.0857 34.2012 16.9902 34.2012Z"
        stroke="#CFBFFB"
        strokeOpacity="0.2"
        strokeWidth="1.0625"
      />
      <path
        d="M15.7222 20.9199C15.5963 20.9199 15.4734 20.8826 15.3688 20.8126C15.2642 20.7426 15.1826 20.6432 15.1345 20.5268C15.0864 20.4105 15.0738 20.2825 15.0983 20.159C15.1228 20.0355 15.1834 19.9221 15.2724 19.833L17.3674 17.7363L15.2724 15.6396C15.2116 15.5809 15.1631 15.5106 15.1298 15.4329C15.0964 15.3553 15.0789 15.2717 15.0781 15.1872C15.0774 15.1026 15.0935 15.0188 15.1255 14.9405C15.1575 14.8623 15.2047 14.7912 15.2645 14.7314C15.3242 14.6716 15.3952 14.6243 15.4734 14.5923C15.5516 14.5603 15.6354 14.5442 15.7199 14.5449C15.8044 14.5457 15.8878 14.5632 15.9655 14.5966C16.0431 14.63 16.1133 14.6785 16.1719 14.7393L18.7168 17.2862C18.8361 17.4056 18.9031 17.5675 18.9031 17.7363C18.9031 17.9052 18.8361 18.0671 18.7168 18.1865L16.1719 20.7334C16.0527 20.8528 15.8909 20.9199 15.7222 20.9199Z"
        fill="white"
      />
    </svg>
  );
};

export default CalendarNextIcon;
